import { gql } from '@apollo/client';
import { ContactEmailFragment } from 'graphql/ContactEmail/fragments/ContactEmailFragment';
import { ContactPhoneFragment } from 'graphql/ContactPhone/fragments/ContactPhoneFragment';
import { TagFragment } from 'graphql/Tag/fragments/TagFragment';
/**
 * @fragment ContactListFragment
 * @since 1.0.0
 */
export const ContactListFragment = gql `
  fragment ContactListFragment on Contact {
    id
    title
    firstname
    lastname
    fullname
    primary
    manager
    status
    marketingOptIn
    marketingOptInAt
    marketingOptInSource

    language {
      code
    }

    image {
      id
      url
    }

    emails {
      ...ContactEmailFragment
    }

    phones {
      ...ContactPhoneFragment
    }

    primaryEmail {
      ...ContactEmailFragment
    }

    primaryPhone {
      ...ContactPhoneFragment
    }

    client {
      id
      name
      number
    }

    tags {
      ...TagFragment
    }
  }

  ${ContactEmailFragment}
  ${ContactPhoneFragment}
  ${TagFragment}
`;
